import { render, staticRenderFns } from "./authProduct.vue?vue&type=template&id=57c7a186&scoped=true&"
import script from "./authProduct.vue?vue&type=script&lang=js&"
export * from "./authProduct.vue?vue&type=script&lang=js&"
import style0 from "./authProduct.vue?vue&type=style&index=0&id=57c7a186&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c7a186",
  null
  
)

export default component.exports